export const itemNameMap: {
  [key: string]: string | { [key: string]: string };
} = {
  memoAD: 'メモ(AD)は',
  memoSV: 'メモ(SV)は',
  policyNumberRevised: '証券番号（修正後）は',
  nameRevised: '契約者名（修正後・漢字）は',
  nameKanaRevised: '契約者名（修正後・カナ）は',
  memo: 'メモは',
  callDesignatedDate: 'コール指定日は',
  callDesignatedTimeAndMemo: 'コール情報の時間等のメモは',
  callHistories: {
    outboundDate: 'コール履歴のコール日は',
    memo: 'コール履歴のメモは',
  },
  responseStatus: 'ステータスは',
};
